import { OrderSection } from '../order-section/order-section';
import React, { useEffect, useState } from 'react';
import { Order } from '../../../clients/quipli-service/order/order';
import { useAPI } from '../../../clients/quipli-service/quipli-service-client';
import './order-invoices.scss';
import { InvoiceList } from '../../collectibles/invoice-list';
import { Card } from '../../../components/card/card';
import { displayMoneyFormat } from '../../../util/util';
import { DateTime } from 'luxon';
import _ from 'lodash';
import { PaymentStatus } from '../../../clients/quipli-service/payment/payment';
import { InvoiceStatus } from '../../../clients/quipli-service/invoice/invoice';
import classNames from 'classnames';

export const OrderInvoices = ({ orderId, className }: { orderId: number; className?: string }) => {
  const { getOrderById, getMultipleConfigurations } = useAPI();
  const [order, setOrder] = useState<Order>();
  const [currency, setCurrency] = useState<string>();
  const [displayTaxByJurisdiction, setDisplayTaxByJurisdiction] = useState<boolean>();

  useEffect(() => {
    getOrderById(orderId).then(setOrder);
    getMultipleConfigurations(['CONF_CURRENCY', 'CONF_DISPLAY_JURISDICTION_TAXES_BREAKDOWN']).then((confs) => {
      setCurrency(confs.find((c) => c.variable === 'CONF_CURRENCY')?.value || 'USD');
      setDisplayTaxByJurisdiction(
        confs.find((c) => c.variable === 'CONF_DISPLAY_JURISDICTION_TAXES_BREAKDOWN')?.value === '1',
      );
    });
  }, []);

  document.getElementsByName('order-invoices').forEach((element) =>
    element.addEventListener('refresh', () => {
      getOrderById(orderId).then(setOrder);
    }),
  );

  return (
    <OrderSection className={classNames('order-invoices flex flex-column gap-2', className)} header="Invoices">
      {currency && order && displayTaxByJurisdiction !== undefined && (
        <>
          <div className="summary-row">
            <Card className="flex flex-column grow">
              <span>Past Due</span>
              <span>
                {displayMoneyFormat(
                  _.sum(
                    order.invoices
                      .filter(
                        (inv) =>
                          inv.status === InvoiceStatus.Approved &&
                          inv.dueDate &&
                          inv.dueDate!.diff(DateTime.now()).as('days') < 0,
                      )
                      .map((inv) => inv.balance),
                  ),
                )}
              </span>
            </Card>
            <Card className="flex flex-column grow">
              <span>Payable</span>
              <span>
                {displayMoneyFormat(
                  _.sum(
                    order.invoices
                      .filter(
                        (inv) =>
                          inv.status === InvoiceStatus.Approved &&
                          inv.date!.diff(DateTime.now()).as('days') < 0 &&
                          (!inv.dueDate || inv.dueDate!.diff(DateTime.now()).as('days') >= 0),
                      )
                      .map((inv) => inv.balance),
                  ),
                )}
              </span>
            </Card>
            <Card className="flex flex-column grow">
              <span>Received</span>
              <span>
                {displayMoneyFormat(
                  _.sum(
                    order.invoices
                      .flatMap((inv) => inv.payments)
                      .filter((p) => p.status === PaymentStatus.succeeded)
                      .flatMap((p) => p.invoicePayments.map((_) => _.amount)),
                  ),
                )}
              </span>
            </Card>
          </div>
          <InvoiceList
            invoices={order.invoices}
            currency={currency}
            refresh={() => getOrderById(orderId).then(setOrder)}
            enableInvoiceLink={false}
            enabledColumns={['InvoiceNumber', 'DueDate', 'Date', 'Status', 'Total', 'Payments', 'Balance', 'Actions']}
            displayTaxByJurisdiction={displayTaxByJurisdiction}
          />
        </>
      )}
    </OrderSection>
  );
};
